import { render } from "./Defeat.vue?vue&type=template&id=34f84d0f&ts=true"
import script from "./Defeat.vue?vue&type=script&lang=ts"
export * from "./Defeat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__